import React, { useEffect, useState } from "react";
import { PageHead } from "@/pages/admin/Layout";
import { api, mediaUrl } from "@/lib/admin/api";

export default function Media() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const fileRef = React.useRef();

  const load = async () => {
    try { setItems(await api.listMedia()); } catch (_) { setItems([]); }
  };
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    setBusy(true);
    for (const f of files) {
      try { await api.uploadMedia(f); } catch (ex) { console.error(ex); }
    }
    setBusy(false);
    e.target.value = "";
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this file permanently?")) return;
    await api.deleteMedia(id);
    load();
  };

  const copy = (text) => {
    navigator.clipboard.writeText(text);
    const el = document.createElement("div");
    el.textContent = "URL copied";
    el.style.cssText = "position:fixed;bottom:30px;left:50%;transform:translateX(-50%);background:#c9b88a;color:#04060f;padding:10px 20px;border-radius:30px;z-index:9999;font-size:11px;letter-spacing:.18em";
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 1500);
  };

  return (
    <div data-testid="media-page" className="max-w-6xl">
      <PageHead
        eye="MEDIA LIBRARY"
        title="Images & Files"
        sub="Drop images here. Each upload is auto-converted to WebP (sm / md / lg). Videos compressed via ffmpeg with poster thumbnail."
        right={
          <>
            <input
              type="file"
              ref={fileRef}
              hidden
              multiple
              accept="image/*,video/*"
              onChange={upload}
              data-testid="media-input"
            />
            <button
              onClick={() => fileRef.current && fileRef.current.click()}
              data-testid="btn-upload"
              className="px-4 py-2 rounded-md bg-[#c9b88a] text-[#04060f] text-[10px] tracking-[.28em] uppercase font-medium hover:bg-white transition"
            >
              {busy ? "Uploading..." : "+ Upload"}
            </button>
          </>
        }
      />

      <div className="rounded-xl border border-[#c9b88a]/15 bg-white/[0.02] p-4">
        {items.length === 0 ? (
          <div className="text-center py-10 text-[#e8e4d8]/40 text-sm">
            No media yet. Click Upload to add your first asset.
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {items.map((m) => (
              <div
                key={m.id}
                className="rounded-lg overflow-hidden border border-[#c9b88a]/15 bg-white/[0.03]"
                data-testid={`media-${m.id}`}
              >
                <div
                  className="aspect-square bg-cover bg-center bg-white/5"
                  style={{ backgroundImage: m.is_image ? `url('${mediaUrl(m.url)}')` : undefined }}
                >
                  {!m.is_image && (
                    <div className="flex items-center justify-center h-full text-[#c9b88a]/60 text-[10px] tracking-[.32em] uppercase">
                      {m.ext} file
                    </div>
                  )}
                </div>
                <div className="p-3">
                  <div className="text-[11px] text-[#e8e4d8]/85 truncate" title={m.filename}>
                    {m.filename}
                  </div>
                  <div className="text-[9px] tracking-[.18em] uppercase text-[#e8e4d8]/35 mt-1">
                    {(m.size_bytes / 1024).toFixed(0)} KB
                  </div>
                  <div className="flex gap-1.5 mt-2">
                    <button
                      onClick={() => copy(mediaUrl(m.url))}
                      className="flex-1 px-2 py-1.5 rounded-md text-[9px] tracking-[.2em] uppercase bg-white/5 border border-[#c9b88a]/15 text-[#e8e4d8]/85 hover:bg-[#c9b88a] hover:text-[#04060f]"
                      data-testid={`copy-url-${m.id}`}
                    >
                      Copy URL
                    </button>
                    <button
                      onClick={() => remove(m.id)}
                      className="px-2 py-1.5 rounded-md text-[9px] tracking-[.2em] uppercase bg-red-500/10 border border-red-500/30 text-red-300 hover:bg-red-500/20"
                      data-testid={`del-media-${m.id}`}
                    >
                      ✕
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
